import React from 'react';
import ReactDOM from 'react-dom/client';
import AIEvolutionGame from './AIEvolutionGame';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AIEvolutionGame />);
